import plannerSettingsModalEn from "./locales/en.json";

export const PLANNER_SETTINGS_MODAL_NS = "plannerSettingsModal" as const;

export const PlannerSettingsModalTranslations = {
  en: {
    [PLANNER_SETTINGS_MODAL_NS]: {
      ...plannerSettingsModalEn,
    },
  },
};
